//export const Auth0Login = () => {
//  const { loginWithRedirect, isAuthenticated } = useAuth0()
//  //useEffect(() => {
//  //  loginWithRedirect().then(r => )
//  //}, [loginWithRedirect])
//
//  if (isAuthenticated) {
//    return <Auth0Profile />
//  }
//  //else {
//  //  loginWithRedirect()
//  //}
//
//  return (
//    //<></>
//    <>
//      <button onClick={() => loginWithRedirect()}>Log In</button>
//    </>
//  )
//}

import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { IpponLoginPage } from '../pages/ippon-login-page.tsx'

export const Auth0Login = () => {
  const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect()
    }
  }, [isLoading, isAuthenticated, loginWithRedirect])

  if (isLoading) {
    return <div>Loading...</div>
  }

  if (isAuthenticated) {
    return <IpponLoginPage />
    //return <Auth0Profile />
  }

  return null
}
